import moment from "moment";

// Date-only values (e.g. date of birth) are stored as UTC midnight of the calendar date,
// so they print the same day regardless of the reader's timezone (the backend runs in UTC).
// Legacy values were saved as the browser's local midnight (e.g. 21:00Z the day before in Greece);
// rounding to the nearest UTC midnight recovers the intended date for any offset within ±12h.
export function normalizeDateOnly(value: Date | string | undefined | null): Date | undefined {
  if (!value) return undefined;
  const m = moment.utc(value);
  if (!m.isValid()) return undefined;
  return m.add(12, "hours").startOf("day").toDate();
}

// Stored date-only value -> local midnight of the same calendar day (what flatpickr expects)
export function dateOnlyToPickerDate(value: Date | string | undefined | null): Date | undefined {
  const utcDate = normalizeDateOnly(value);
  if (!utcDate) return undefined;
  return new Date(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate());
}

// Date picked in flatpickr (local midnight) -> UTC midnight of the same calendar day
export function pickerDateToDateOnly(date: Date | undefined): Date | undefined {
  if (!date) return undefined;
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
}

export function formatDateOnly(value: Date | string | undefined | null, format = "DD/MM/YYYY"): string {
  const utcDate = normalizeDateOnly(value);
  return utcDate ? moment.utc(utcDate).format(format) : "";
}
